'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var serif = 'Georgia, serif';
var monospace = 'Menlo, Consolas, monospace';

var baseColors = {
  black: '#111',
  white: '#fff',
  gray: '#eee',
  midgray: '#888',
  blue: '#008cef',
  red: '#ef0034',
  orange: '#FFCD29',
  green: '#00ef50',
  lighten: 'rgba(255, 255, 255, ' + 1 / 16 + ')',
  darken: 'rgba(0, 0, 0, ' + 1 / 16 + ')'
};

var colors = _extends({}, baseColors, {
  primary: baseColors.blue,
  secondary: baseColors.midgray,
  default: baseColors.black,
  muted: baseColors.gray,
  info: baseColors.blue,
  success: baseColors.green,
  warning: baseColors.orange,
  error: baseColors.red
});

var scale = [0, 8, 16, 32, 64];

var fontSizes = [48, 32, 24, 20, 16, 14, 12];

var zIndex = [0, 2, 4, 8, 16];

var bold = 600;
var borderRadius = 2;
var borderColor = 'rgba(0, 0, 0, .25)';
var boxShadow = '0 2px 16px rgba(0, 0, 0, .125)';

var caps = {
  textTransform: 'uppercase',
  letterSpacing: '.2em'
};

var basic = {
  name: 'Basic',
  scale: scale,
  fontSizes: fontSizes,
  bold: bold,
  serif: serif,
  monospace: monospace,
  caps: caps,
  zIndex: zIndex,
  colors: colors,
  borderRadius: borderRadius,
  borderColor: borderColor,
  boxShadow: boxShadow,
  Heading: {
    alt: _extends({}, caps)
  }
};

exports.default = basic;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/themes/basic.js
// module id = Fmfl
// module chunks = 1